import { Link, To } from "react-router-dom";

interface NewsComingSoonProps {
  /** Where "see upcoming webinars" goes: the webinars page, or the events section lower on /news */
  eventsLink: To;
  /** Position in the grid, used to stagger the scroll reveal */
  revealOrder?: number;
}

// Holds the place of the first article, on the homepage and the news page, until one is live
// (status "published" and its date reached: see src/content/news.ts). It goes by itself then.
export default function NewsComingSoon({ eventsLink, revealOrder = 0 }: NewsComingSoonProps) {
  return (
    <article className="km-card nw-card nw-card--soon" data-reveal style={{ "--reveal-order": revealOrder } as React.CSSProperties}>
      <div className="nw-soon-art" aria-hidden="true">
        <svg viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10 14h36v34a6 6 0 0 1-6 6H16a6 6 0 0 1-6-6z" />
          <path d="M46 24h8v24a6 6 0 0 1-6 6" />
          <rect x="17" y="21" width="12" height="10" rx="1.5" />
          <path d="M34 22h5M34 29h5M17 38h22M17 45h16" />
        </svg>
      </div>
      <div className="nw-card-body">
        <p className="nw-meta"><span className="nw-chip nw-chip--soon">Coming soon</span></p>
        <h3 className="nw-card-title">Our first article is on its way</h3>
        <p className="nw-card-summary">
          Practical updates on medical devices, SAHPRA licensing and our webinars, from the Kole Medical team. Check back soon.
        </p>
        <Link className="nw-card-more nw-soon-link" to={eventsLink}>
          Meanwhile, see upcoming webinars <span className="km-arrow" aria-hidden="true">→</span>
        </Link>
      </div>
    </article>
  );
}
